import React, {useCallback, useMemo, useState} from "react";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Modal, {ModalPortal} from "features/components/modal";
import {TextField} from "features/components/text-field";
import {EmailValidator} from "services/utils/validations";
import Button from "features/components/button";
import {connect} from "react-redux";
import {forgotStart, forgotReset} from "features/pages/account/forgot-password/reducer";
import {forgotLoading, forgotSuccess} from "features/pages/account/forgot-password/selectors";
import {Icon} from "features/components/icon";
import "./index.scss";
import {HELP_EMAIL} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: forgotLoading(state),
    success: forgotSuccess(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    forgotStart,
    forgotReset
};

export const ForgotPasswordPage = (props) => {
    const {forgotStart, loading, success, forgotReset} = props;
    const [email, setEmail] = useState("");
    const validateEmail = useCallback((val) => {
        return EmailValidator(val) ? null : __("validator.invalid-email");
    }, []);
    const handleSendEmail = useCallback(() => {
        forgotStart(email);
    }, [email, forgotStart]);
    const handleForgotEmail = useCallback(() => {
        window.open(`mailto:${HELP_EMAIL}`);
    }, []);

    const isSendEnabled = useMemo(() => {
        return EmailValidator(email);
    }, [email]);

    const doReset = useCallback(() => {
        setEmail("");
        forgotReset();
    }, [forgotReset]);


    const showModal = useCallback(() => {
        if(!success) return null;
        return <ModalPortal size={"small"} className={"modal-success-forgot"}>
            <Icon>check-circle-outline</Icon>
            <Title size={24} align={"center"}>{__("forgot-password.success.title")}</Title>
            <Text size={16} align={"center"}>{__("forgot-password.success.text")}</Text>
            <Button title={__("buttons.ok-thanks")} onClick={doReset} icon={"arrow-right"} />
        </ModalPortal>
    }, [success, doReset]);

    return <LoggedOutLayout type={"dark"} className={"forgot-password-page"}>
        <Modal>
            <Title size={34} align={"center"}>{__("forgot-password.title")}</Title>
            <Text size={16} align={"center"}>{__("forgot-password.text")}</Text>
            <div className="field-box">
                <TextField
                    type={"text"}
                    value={email}
                    onChange={setEmail}
                    placeholder={__("text-fields.email.placeholder")}
                    hint={__("text-fields.email.hint")}
                    validationFunc={validateEmail}
                    disabled={loading}
                />
            </div>
            <Button title={__("buttons.send")} disabled={!isSendEnabled} onClick={handleSendEmail} status={loading ? "loading" : null} icon={"arrow-right"} />
            <Button title={__("buttons.forgot-email")} onClick={handleForgotEmail} type={"clear"}  />
            {showModal()}
        </Modal>
    </LoggedOutLayout>
};

ForgotPasswordPage.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);